const Badge = ({ text, addclass }) => {
  return (
    <span
      className={`inline-block px-1 py-0 text-[13px] font-semibold rounded-sm ${addclass}`}
    >
      {text}
    </span>
  );
};

export default Badge;
